(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tc-sort]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-mode-topbar"]) return;
  try {
    
  document.querySelectorAll('[data-tm-topbar]').forEach((bar) => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const items = Array.from(bar.querySelectorAll('[data-tm-topbar-item]'));
    const closeButton = bar.querySelector('[data-tm-topbar-close]');
    const storageKey = 'ss24-mobile-topbar-dismissed';

    if (!mobileQuery.matches || items.length < 2 || !closeButton) return;

    try {
      if (window.sessionStorage.getItem(storageKey) === 'true') {
        bar.classList.add('is-dismissed');
        return;
      }
    } catch (error) {
      bar.dataset.storageUnavailable = 'true';
    }

    let activeIndex = 0;
    let transitionTimer;

    const showNext = () => {
      const currentItem = items[activeIndex];
      const nextIndex = (activeIndex + 1) % items.length;
      const nextItem = items[nextIndex];

      currentItem.classList.remove('is-active');
      currentItem.classList.add('is-leaving');
      nextItem.classList.add('is-active');

      window.clearTimeout(transitionTimer);
      transitionTimer = window.setTimeout(() => {
        currentItem.classList.remove('is-leaving');
      }, 450);

      activeIndex = nextIndex;
    };

    const interval = window.setInterval(showNext, 2500);

    closeButton.addEventListener('click', () => {
      window.clearInterval(interval);
      window.clearTimeout(transitionTimer);
      bar.classList.add('is-dismissed');
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        bar.dataset.storageUnavailable = 'true';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-product-concept"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-tm-pdp-thumb]');
    if (!thumb) return;
    const product = thumb.closest('.tm-pdp');
    const image = product?.querySelector('.tm-pdp__main-image');
    if (!image) return;
    image.src = thumb.dataset.src;
    image.srcset = thumb.dataset.srcset;
    image.alt = thumb.dataset.alt;
    product.querySelectorAll('[data-tm-pdp-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.tm-pdp__select');
    if (!select) return;
    const product = select.closest('.tm-pdp');
    const option = select.options[select.selectedIndex];
    const price = product?.querySelector('.tm-pdp__price');
    const availability = product?.querySelector('.tm-pdp__availability');
    const add = product?.querySelector('.tm-pdp__add');
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price;
    if (availability) availability.classList.toggle('is-unavailable', !available);
    if (add) {
      add.disabled = !available;
      add.querySelector('span').textContent = available ? add.dataset.availableLabel : add.dataset.soldOutLabel;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
